import { Component } from '@angular/core';

@Component({
  selector: 'app-prd-terms-and-condition',
  templateUrl: './prd-terms-and-condition.component.html',
  styleUrls: ['./prd-terms-and-condition.component.scss'],
})
export class PrdTermsAndConditionComponent {
  lastUpdatedDate: Date = new Date('2024-01-01'); // Set the last updated date
}
